enum ServerOutcome {
  NotReached,
  BlockedInQuestions,
  NotAppropriate,
  ShownAdvisors,
  TransferValueTooLow
}

export default ServerOutcome;
